import React, { useState, useEffect } from "react"
import { Layout, Menu, Breadcrumb, Dropdown, Divider, Tooltip } from "antd"
import {
  EditOutlined,
  UserOutlined,
  LockOutlined,
  BellOutlined,
  PlusCircleOutlined,
  SafetyOutlined,
} from "@ant-design/icons"
import { RESTExecutor, withDomains } from "../../lib/domain"
import { CustomButton } from "../../components/forms/buttons"
import {
  PlusOutlined,
  SettingOutlined,
  LogoutOutlined,
  LeftOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from "@ant-design/icons"
import ProfileEditForm from "./editProfile"
import ChangePasswordForm from "./changePassoword"
import AccountOverviewPage from "./accountOverview"
import NotificationsPage from "./notifcations"
import ManageSessionsPage from "./manageSessions"
import { BASE_API_URL } from "../../config"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { getImageUrl } from "../../util/ui_util"
import { TopHeader } from "../../components/top-header"

const { Content, Sider } = Layout

const AccountSettingPage = ({ domains, authenticator, ...props }) => {
  const [userInfo, setUserInfo] = useState({})
  const [forceUpdate, setForceUpdate] = useState(0)
  const [userName, setUserName] = useState("")
  const [imgSource, setImgSource] = useState("")

  let list_namespace = RESTExecutor.list()
    .config({
      label: "list_namespace",
    })
    .connect(domains.user)

  let get_user = RESTExecutor.list()
    .config({
      label: "me",
    })
    .callbacks((success) => {
      console.log("User data received:", success.result)
      
      setUserInfo(success.result)
      
      const nameParts = success.result.name ? success.result.name.split(" ") : ["User", ""]
      const firstName = nameParts[0] || "User"
      const lastName = nameParts[1] || ""
      
      const newImgSource = getImageUrl(success.result)
        ? getImageUrl(success.result)
        : `https://ui-avatars.com/api/?name=${firstName}+${lastName}&background=1ED760&color=fff&size=40&rounded=true`
      
      const newUserName =
        success.result.name == "" ? success.result.email : success.result.name
      
      setImgSource(newImgSource)
      setUserName(newUserName)
      
      console.log("Setting imgSource:", newImgSource)
      console.log("Setting userName:", newUserName)
      
      setForceUpdate(prev => prev + 1)
    }, (error) => {
      console.error("Error fetching user data:", error)
      setImgSource("https://ui-avatars.com/api/?name=User&background=1ED760&color=fff&size=40&rounded=true")
      setUserName("User")
      setForceUpdate(prev => prev + 1)
    })
    .connect(domains.user)

  let upgrade_credentials = RESTExecutor.post()
    .config({
      label: "upgrade_credentials",
    })
    .connect(domains.upgradeCredentials)

  useEffect(() => {
    console.log("Component mounted, executing API calls...")
    try {
      get_user.execute(true)
      list_namespace.execute(true)
    } catch (error) {
      console.error("Error executing API calls:", error)
      setImgSource("https://ui-avatars.com/api/?name=User&background=1ED760&color=fff&size=40&rounded=true")
      setUserName("User")
    }
  }, [])

  useEffect(() => {
    console.log("Component force updated - imgSource:", imgSource, "userName:", userName)
  }, [forceUpdate, imgSource, userName])

  const reloadProps = { 
    get_user,
    userInfo,
    imgSource,
    userName,
    refreshUserData: () => {
      get_user.execute(true)
    }
  }

  let namespace_resp = list_namespace.response()
  
  const CustomDropdownMenu = () => (
    <div className={"dropdown-menu"} style={{ maxHeight: '400px', width: '280px', backgroundColor: 'white', borderRadius: '6px', boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.08)', border: '1px solid #d9d9d9' }}>
      <div style={{ padding: '5px 0' }}>
        <div
          style={{ 
            padding: '5px 12px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            minHeight: '32px'
          }}
          onClick={() => {
            props.history.push("/")
          }}
        >
          <img className="user-avatar-img" src={imgSource} alt="User" style={{ width: '16px', height: '16px', borderRadius: '50%', marginRight: '8px' }} />
          <span className="menu-item-text">{userName}</span>
        </div>
      </div>
      
      <div style={{ height: '1px', backgroundColor: '#f0f0f0', margin: '4px 0' }} />

      <div style={{ padding: '5px 12px', fontSize: '12px', color: '#999', fontWeight: '600' }}>
        Your Companies
      </div>

      <div style={{ 
        maxHeight: '200px', 
        overflowY: 'auto',
        borderTop: '1px solid #f0f0f0',
        borderBottom: '1px solid #f0f0f0',
        margin: '4px 0'
      }}>
        {(namespace_resp?.result ?? []).map((item) => (
          <div
            key={item.slug}
            style={{ 
              padding: '5px 12px',
              cursor: 'pointer',
              minHeight: '32px',
              display: 'flex',
              alignItems: 'center'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f5f5f5'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent'
            }}
            onClick={() => {
              upgrade_credentials.onSuccess = (resp) => {
                let str = ""
                Object.entries(resp.result).map(([k, v]) => (str += `${k}=${v}&`))
                let staging = BASE_API_URL.includes("demo.tigg")
                  ? "/demo/v1"
                  : BASE_API_URL.includes("uat.tigg")
                  ? "/staging"
                  : ""
                window.open(
                  `https://${
                    item.slug
                  }.tigg.app${staging}/#/validate-login?${str.slice(0, -1)}`
                )
              }
              upgrade_credentials.execute({
                namespace: `${item.slug}`,
              })
            }}
          >
            <span className="menu-item-text">{item.name}</span>
          </div>
        ))}
        
        <div
          style={{ 
            padding: '5px 12px',
            cursor: 'pointer',
            minHeight: '32px',
            display: 'flex',
            alignItems: 'center'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#f5f5f5'
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent'
          }}
          onClick={() => {
            props.history.push("/new-company")
          }}
        >
          <PlusOutlined style={{ marginRight: '8px', fontSize: '14px' }} />
          Add New Company
        </div>
      </div>

      <div style={{ padding: '5px 0' }}>        
        <div
          style={{ 
            padding: '5px 28px',
            cursor: 'pointer',
            minHeight: '32px',
            display: 'flex',
            alignItems: 'center'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#f5f5f5'
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent'
          }}
          onClick={() => {
          }}
        >
          <SettingOutlined style={{ marginRight: '8px', fontSize: '14px' }} />
          Account Settings
        </div>

        <div style={{ height: '1px', backgroundColor: '#f0f0f0', margin: '4px 0' }} />
        
        <div
          style={{ 
            padding: '5px 32px',
            cursor: 'pointer',
            minHeight: '32px',
            display: 'flex',
            alignItems: 'center'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#f5f5f5'
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent'
          }}
          onClick={() => {
            authenticator.logout()
            history.push("/")
          }}
        >
          <LogoutOutlined style={{ marginRight: '8px', fontSize: '14px' }} />
          Logout
        </div>
      </div>
    </div>
  )

  let menu = <CustomDropdownMenu />

  const [collapsed, setCollapsed] = useState(false)

  let handleCollapse = () => {
    setCollapsed(!collapsed)
  }

  const [selectedMenu, setSelectedMenu] = useState("2")

  let handleClick = (key) => {
    setSelectedMenu(key.key)
  }
  const history = useHistory()

  return (
    <div
      className={"application-container"}
      style={{ backgroundColor: "#EEF2F7" }}
    >
      <div className="main-header-menu" style={{ position: 'relative', zIndex: 1000 }}>
        <TopHeader userInfo={userInfo} menu={menu} imgSource={imgSource} />
      </div>

      <div className="settings-container">
        <Layout className="settings-layout">
          <Sider
            theme="light"
            breakpoint="lg"
            trigger={null}
            collapsible
            collapsed={collapsed}
            onCollapse={handleCollapse}
            width={'250px'}
          >
            <Menu
              theme="light"
              defaultSelectedKeys={["2"]}
              mode="inline"
              onClick={handleClick}
              style={{ paddingTop: "20px" }}
            >
              <Menu.Item
                className="account-setting-form-header"
                style={{ marginBottom: "25px" }}
                key="back"
                icon={<LeftOutlined />}
                onClick={() => {
                  props.history.goBack()
                }}
              >
                Account Settings
              </Menu.Item>
              <Menu.Item key="1" icon={<UserOutlined />}>
                Account Overview
              </Menu.Item>
              <Menu.Item key="2" icon={<EditOutlined />}>
                Edit Profile
              </Menu.Item>
              <Menu.Item key="3" icon={<LockOutlined />}>
                Change Password
              </Menu.Item>
              <Menu.Item key="4" icon={<SafetyOutlined />}>
                Security
              </Menu.Item>
            </Menu>
          </Sider>
          <Layout className="site-layout">
            <Content style={{ margin: "0px 10px" }}>
              <>
                {(() => {
                  switch (selectedMenu) {
                    case "1":
                      return <AccountOverviewPage domains={domains} {...reloadProps} />
                    case "2":
                      return <ProfileEditForm {...reloadProps} />
                    case "3":
                      return <ChangePasswordForm />
                    case "4":
                      return <ManageSessionsPage domains={domains} {...reloadProps} />
                    case "5":
                      return <NotificationsPage />
                    default:
                      break
                  }
                })()}
              </>
            </Content>
          </Layout>
        </Layout>
      </div>
    </div>
  )
}

export default withDomains(
  AccountSettingPage,
  "register",
  "user",
  "auth",
  "upgradeCredentials",
  "fileUpload",
  "trustedDevices",
  "password"
)
